namespace GeniuzPOS.Member {
    export interface PsMemberForm {
        MbId: Serenity.StringEditor;
        MbNameT: Serenity.StringEditor;
        MbNameE: Serenity.StringEditor;
        MbNation: Serenity.StringEditor;
        MbRace: Serenity.StringEditor;
        MbBirthDay: Serenity.DateEditor;
        MbPid: Serenity.StringEditor;
        MbGender: Serenity.RadioButtonEditor;
        MbOccupation: Serenity.StringEditor;
        MbTelNo: Serenity.StringEditor;
        MbEmail: Serenity.StringEditor;
        MbPhoto: Serenity.ImageUploadEditor;
        MbMemo: Serenity.TextAreaEditor;
        MbAddress: Serenity.TextAreaEditor;
        MbTumbol: Serenity.StringEditor;
        MbAmphur: Serenity.StringEditor;
        MbProvince: Serenity.StringEditor;
        MbZipCode: Serenity.StringEditor;
        MbLineAddr1: Serenity.StringEditor;
        MbLineAddr2: Serenity.StringEditor;
        MbLineAddr3: Serenity.StringEditor;
        MbCardStatus: Serenity.RadioButtonEditor;
        MbType: Serenity.LookupEditor;
        MbCardType: Serenity.StringEditor;
        MbApplyDate: Serenity.DateEditor;
        MbExpireDate: Serenity.DateEditor;
        ApplyShopId: Serenity.LookupEditor;
        MbAccumPoint: Serenity.DecimalEditor;
        MbNearlyExpirePoint: Serenity.DecimalEditor;
        MbExpirePointDate: Serenity.DateEditor;
    }

    export class PsMemberForm extends Serenity.PrefixedContext {
        static formKey = 'Member.PsMember';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsMemberForm.init)  {
                PsMemberForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;
                var w2 = s.RadioButtonEditor;
                var w3 = s.ImageUploadEditor;
                var w4 = s.TextAreaEditor;
                var w5 = s.LookupEditor;
                var w6 = s.DecimalEditor;

                Q.initFormType(PsMemberForm, [
                    'MbId', w0,
                    'MbNameT', w0,
                    'MbNameE', w0,
                    'MbNation', w0,
                    'MbRace', w0,
                    'MbBirthDay', w1,
                    'MbPid', w0,
                    'MbGender', w2,
                    'MbOccupation', w0,
                    'MbTelNo', w0,
                    'MbEmail', w0,
                    'MbPhoto', w3,
                    'MbMemo', w4,
                    'MbAddress', w4,
                    'MbTumbol', w0,
                    'MbAmphur', w0,
                    'MbProvince', w0,
                    'MbZipCode', w0,
                    'MbLineAddr1', w0,
                    'MbLineAddr2', w0,
                    'MbLineAddr3', w0,
                    'MbCardStatus', w2,
                    'MbType', w5,
                    'MbCardType', w0,
                    'MbApplyDate', w1,
                    'MbExpireDate', w1,
                    'ApplyShopId', w5,
                    'MbAccumPoint', w6,
                    'MbNearlyExpirePoint', w6,
                    'MbExpirePointDate', w1
                ]);
            }
        }
    }
}
